import {
  ContactFormProps,
  ContactFormField,
  ContactFormNotification,
} from "../../../features/forms/types"

const toContactFormField = (field: any): ContactFormField => {
  return {
    type: field.type,
    label: field.label,
    placeholder: field.placeholder,
    required: field.required,
    requiredErrorMessage: field.requiredErrorMessage,
    invalidErrorMessage: field.invalidErrorMessage,
    fieldSize: field.fieldSize,
    options: field.options ?? [],
  }
}

export const toContactFormProps = (item: any): ContactFormProps => {
  const fields: ContactFormField[] = item.data?.fields?.map(toContactFormField)
  const cta: string = item.data?.cta.label
  const notifications: ContactFormNotification = {
    user: item.data?.notifications.userNotification._ref,
    internal: item.data?.notifications.internalNotification._ref,
  }

  return { fields, cta, notifications }
}
